<template>
    <Loading>
        <div class="personal-details-skeleton-root p-4 mb-3">
            <div class="flex-grow">
                <Row class="w-50" rounded />
                <Row class="input-row mb-4" rounded />
                <Row class="w-50" rounded />
                <Row class="input-row mb-4" rounded />
                <Row class="w-50" rounded />
                <Row class="input-row" rounded />
            </div>
            <div class="d-flex flex-column align-items-center">
                <Avatar class="avatar-image mt-3" />
                <div class="flex-grow" />
                <Row class="button-row mt-4" rounded />
            </div>
        </div>
    </Loading>
</template>

<script>
import Loading from '~/components/skeletons/base/Loading';
import Avatar from '~/components/skeletons/base/Avatar';
import Row from '~/components/skeletons/base/Row';

export default {
    name: 'PersonalDetailsSkeleton',
    components: { Loading, Avatar, Row },
};
</script>

<style scoped>
.personal-details-skeleton-root {
    display: grid;
    grid-gap: 22px;
    grid-template-columns: 3fr 2fr;
}

.input-row {
    height: 38px;
    width: 100%;
}

.avatar-image {
    width: 140px;
    height: 140px;
}

.button-row {
    width: 100%;
    height: 38px;
}

@media only screen and (max-width: 600px) {
    .personal-details-skeleton-root {
        grid-template-columns: 1fr;
    }
}
</style>
